<template>
    <div class="testimonials-wrap relative">
        <div ref="splide" class="splide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li v-for="(testimonial, index) in sanitizedTestimonials" :key="index" class="splide__slide">
                        <div class="testimonial">
                            <div class="testimonial-content">
                                {{ testimonial.text }}
                            </div>
                            <div class="testimonial-name">{{ testimonial.name }}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <template v-if="sanitizedTestimonials.length > 1">
            <button class="splide__arrow splide__arrow--prev custom-arrow--prev"
                    aria-label="Previous"
                    @click="prevSlide">
                <svg class="testimonial-arrow">
                    <use :href="iconsPublicUrl + '#arrow-left'"></use>
                </svg>
            </button>
            <button class="splide__arrow splide__arrow--next custom-arrow--next"
                    aria-label="Next"
                    @click="nextSlide">
                <svg class="testimonial-arrow">
                    <use :href="iconsPublicUrl + '#arrow-right'"></use>
                </svg>
            </button>
        </template>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

defineOptions({ name: 'TestimonialsSlider' });

const props = defineProps({
    testimonialsSource: {
        type: Array,
        required: true,
    },
});

const iconsPublicUrl = '/images/icons-public.svg';
const splide = ref(null);
let splideInstance = null;

function stripHtml (html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

const sanitizedTestimonials = computed(() => {
    return props.testimonialsSource.map(testimonial => ({
        ...testimonial,
        text: stripHtml(testimonial.text),
    }));
});

function nextSlide () {
    if (splideInstance) {
        splideInstance.go('>');
    }
}

function prevSlide () {
    if (splideInstance) {
        splideInstance.go('<');
    }
}

onMounted(() => {
    splideInstance = new Splide(splide.value, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        arrows: false, // Disable Splide's default arrows
        pagination: true,
    }).mount();
});
</script>
